import { SubComponentModel } from '@secca/case/components/case-plans/case-plans/add-service-order/models/interfaces';

export class SubLuggageReference implements SubComponentModel {
  pirNumber: string;
  policeReportReference: string;

  public constructor(init?: Partial<SubLuggageReference>) {
    Object.assign(this, init);
  }

  isValid(): boolean {
    return true;
  }

}
